"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPhoto = addPhoto;
exports.authorizedGuestWatcher = authorizedGuestWatcher;
exports.create = create;
exports.list = list;
exports.patch = patch;
exports.remove = remove;
exports.removePhoto = removePhoto;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _effects = require("redux-saga/effects");
var _services = require("../../../services");
var _variables = require("../../Notification/variables");
var _utils = require("../../../utils");
var _variables2 = require("../variables");
var _helpers = require("@qwkin/helpers");
var _variables3 = require("../../Unit/variables");
var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(authorizedGuestWatcher);
function list(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var response, _response$data, _response$data2, _response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.AuthorizedGuestService.list, payload);
        case 3:
          response = _context.sent;
          _context.next = 6;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_LIST_SUCCESS,
            payload: response
          });
        case 6:
          _context.next = 16;
          break;
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          _response = _context.t0.response;
          _context.next = 13;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_LIST_FAIL,
            payload: _response
          });
        case 13:
          _context.next = 15;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response$data = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data !== void 0 ? _response$data : {}),
              data: _response
            }
          });
        case 15:
          (0, _utils.logErr)((_response$data2 = _response === null || _response === void 0 ? void 0 : _response.data) !== null && _response$data2 !== void 0 ? _response$data2 : {});
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  })();
}
function create(_ref3) {
  var payload = _ref3.payload,
    _ref3$callback = _ref3.callback,
    callback = _ref3$callback === void 0 ? _helpers.identity : _ref3$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var response, _response2$data, _response2$data2, _response2;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.AuthorizedGuestService.create, payload);
        case 3:
          response = _context2.sent;
          _context2.next = 6;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_CREATE_SUCCESS,
            payload: response
          });
        case 6:
          _context2.next = 8;
          return (0, _effects.put)({
            type: _variables3.SHOULD_UPDATE_DATA
          });
        case 8:
          _context2.next = 10;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Auth. guest created successfully'
            }
          });
        case 10:
          callback(response === null || response === void 0 ? void 0 : response.data);
          _context2.next = 21;
          break;
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](0);
          _response2 = _context2.t0.response;
          _context2.next = 18;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_CREATE_FAIL,
            payload: _response2
          });
        case 18:
          _context2.next = 20;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response2$data = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data !== void 0 ? _response2$data : {}),
              data: _response2
            }
          });
        case 20:
          (0, _utils.logErr)((_response2$data2 = _response2 === null || _response2 === void 0 ? void 0 : _response2.data) !== null && _response2$data2 !== void 0 ? _response2$data2 : {});
        case 21:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 13]]);
  })();
}
function patch(_ref5) {
  var payload = _ref5.payload,
    _ref5$callback = _ref5.callback,
    callback = _ref5$callback === void 0 ? _helpers.identity : _ref5$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var response, _response3$data, _response3$data2, _response3;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.AuthorizedGuestService.patch, payload);
        case 3:
          response = _context3.sent;
          _context3.next = 6;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_PATCH_SUCCESS,
            payload: response
          });
        case 6:
          _context3.next = 8;
          return (0, _effects.put)({
            type: _variables3.SHOULD_UPDATE_DATA
          });
        case 8:
          _context3.next = 10;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Auth. guest edited successfully'
            }
          });
        case 10:
          callback(response === null || response === void 0 ? void 0 : response.data);
          _context3.next = 21;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](0);
          _response3 = _context3.t0.response;
          _context3.next = 18;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_PATCH_FAIL,
            payload: _response3
          });
        case 18:
          _context3.next = 20;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response3$data = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data !== void 0 ? _response3$data : {}),
              data: _response3
            }
          });
        case 20:
          (0, _utils.logErr)((_response3$data2 = _response3 === null || _response3 === void 0 ? void 0 : _response3.data) !== null && _response3$data2 !== void 0 ? _response3$data2 : {});
        case 21:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 13]]);
  })();
}
function addPhoto(_ref7) {
  var payload = _ref7.payload,
    meta = _ref7.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    var response, _response4$data, _response4$data2, _response4;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.AuthorizedGuestService.addPhoto, payload);
        case 3:
          response = _context4.sent;
          _context4.next = 6;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_ADD_PHOTO_SUCCESS,
            payload: response
          });
        case 6:
          _context4.next = 8;
          return (0, _effects.put)({
            type: _variables3.SHOULD_UPDATE_DATA
          });
        case 8:
          meta === null || meta === void 0 || meta.callback(response === null || response === void 0 ? void 0 : response.data);
          _context4.next = 19;
          break;
        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](0);
          _response4 = _context4.t0.response;
          _context4.next = 16;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_ADD_PHOTO_FAIL,
            payload: _response4
          });
        case 16:
          _context4.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response4$data = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data !== void 0 ? _response4$data : {}),
              data: _response4
            }
          });
        case 18:
          (0, _utils.logErr)((_response4$data2 = _response4 === null || _response4 === void 0 ? void 0 : _response4.data) !== null && _response4$data2 !== void 0 ? _response4$data2 : {});
        case 19:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 11]]);
  })();
}
function removePhoto(_ref9) {
  var payload = _ref9.payload,
    meta = _ref9.meta;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var response, _response5$data, _response5$data2, _response5;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.AuthorizedGuestService.removePhoto, payload);
        case 3:
          response = _context5.sent;
          _context5.next = 6;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_REMOVE_PHOTO_SUCCESS,
            payload: response
          });
        case 6:
          _context5.next = 8;
          return (0, _effects.put)({
            type: _variables3.SHOULD_UPDATE_DATA
          });
        case 8:
          meta === null || meta === void 0 || meta.callback(response === null || response === void 0 ? void 0 : response.data);
          _context5.next = 19;
          break;
        case 11:
          _context5.prev = 11;
          _context5.t0 = _context5["catch"](0);
          _response5 = _context5.t0.response;
          _context5.next = 16;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_REMOVE_PHOTO_FAIL,
            payload: _response5
          });
        case 16:
          _context5.next = 18;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response5$data = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data !== void 0 ? _response5$data : {}),
              data: _response5
            }
          });
        case 18:
          (0, _utils.logErr)((_response5$data2 = _response5 === null || _response5 === void 0 ? void 0 : _response5.data) !== null && _response5$data2 !== void 0 ? _response5$data2 : {});
        case 19:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 11]]);
  })();
}
function remove(_ref11) {
  var payload = _ref11.payload,
    _ref11$callback = _ref11.callback,
    callback = _ref11$callback === void 0 ? _helpers.identity : _ref11$callback;
  return /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var response, _response6$data, _response6$data2, _response6;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.AuthorizedGuestService["delete"], payload);
        case 3:
          response = _context6.sent;
          _context6.next = 6;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_REMOVE_SUCCESS,
            payload: response
          });
        case 6:
          _context6.next = 8;
          return (0, _effects.put)({
            type: _variables3.SHOULD_UPDATE_DATA
          });
        case 8:
          _context6.next = 10;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'success',
              message: 'Auth. guest deleted successfully'
            }
          });
        case 10:
          callback();
          _context6.next = 21;
          break;
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](0);
          _response6 = _context6.t0.response;
          _context6.next = 18;
          return (0, _effects.put)({
            type: _variables2.AUTHORIZED_GUEST_REMOVE_FAIL,
            payload: _response6
          });
        case 18:
          _context6.next = 20;
          return (0, _effects.put)({
            type: _variables.NOTIFY,
            payload: {
              variant: 'error',
              message: (0, _utils.getErrorMsg)((_response6$data = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data !== void 0 ? _response6$data : {}),
              data: _response6
            }
          });
        case 20:
          (0, _utils.logErr)((_response6$data2 = _response6 === null || _response6 === void 0 ? void 0 : _response6.data) !== null && _response6$data2 !== void 0 ? _response6$data2 : {});
        case 21:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 13]]);
  })();
}
function authorizedGuestWatcher() {
  return _regenerator["default"].wrap(function authorizedGuestWatcher$(_context7) {
    while (1) switch (_context7.prev = _context7.next) {
      case 0:
        _context7.next = 2;
        return (0, _effects.all)([(0, _effects.takeLatest)(_variables2.AUTHORIZED_GUEST_LIST_REQUEST, list), (0, _effects.takeLatest)(_variables2.AUTHORIZED_GUEST_CREATE_REQUEST, create), (0, _effects.takeLatest)(_variables2.AUTHORIZED_GUEST_PATCH_REQUEST, patch), (0, _effects.takeLatest)(_variables2.AUTHORIZED_GUEST_ADD_PHOTO_REQUEST, addPhoto), (0, _effects.takeLatest)(_variables2.AUTHORIZED_GUEST_REMOVE_PHOTO_REQUEST, removePhoto), (0, _effects.takeLatest)(_variables2.AUTHORIZED_GUEST_REMOVE_REQUEST, remove)]);
      case 2:
      case "end":
        return _context7.stop();
    }
  }, _marked);
}